import {
    COLORS,
    DEFAULT_RATIO,
    FONT_PRESETS,
    FONT_SIZES,
    TEXT_STYLES,
} from "../resultTheme";

const zone = (top, left, width, height) => ({ top, left, width, height });
const topBarZones = (date, time) => ({ date, time });
const loZones = (lo2d, lo3d) => ({ lo2d, lo3d });
const combineZones = (topBar, lo) => ({ ...topBar, ...lo });
const postArea = (left, width, startTop, rowHeight) => ({
    frame: { left, width },
    rows: { startTop, rowHeight },
});

export const DAY_TOPBAR_ZONES = topBarZones(
    zone(9.8, 7, 43, 5),
    zone(9.8, 65, 23, 5)
);

export const NIGHT_TOPBAR_ZONES = topBarZones(
    zone(9.8, 7, 43, 5),
    zone(9.8, 65, 23, 5)
);

export const MC_DAY_ZONES = combineZones(
    DAY_TOPBAR_ZONES,
    loZones(zone(27, 51.5, 20, 51), zone(27, 72.3, 25, 51))
);

export const MT_DAY_ZONES = combineZones(
    DAY_TOPBAR_ZONES,
    loZones(zone(26.5, 51.5, 20, 51), zone(26.5, 72.3, 25, 51))
);


export const NIGHT_A_GROUP = {
    frame: { top: 31.8, left: 4.5, width: 41.5, height: 11.2 },
    codes: {
        twoD: ["A", "A1", "A2", "A3", "A4"],
        threeD: ["A", "A2", "A3"],
    },
    layout: {
        twoDColumns: 4,
        threeDColumns: 3,
        twoDHeight: "1fr",
        threeDHeight: "1fr",
        rowGap: "18%",
        twoDGap: "4%",
        threeDGap: "6%",
    },
    fontSize: FONT_SIZES.large,
};

export const TC_DAY_ZONES = combineZones(
    DAY_TOPBAR_ZONES,
    loZones(zone(27.5, 52.6, 18, 51), zone(27.5, 72, 25, 51))
);

export const KH_DAY_ZONES = combineZones(
    topBarZones(zone(19.8, 11, 43, 5), zone(19.8, 60, 25, 5)),
    loZones(zone(27, 52.6, 18, 51), zone(27, 71, 27, 51))
);

export const SC_DAY_ZONES = combineZones(
    topBarZones(zone(10.3, 11, 43, 5), zone(10.3, 60, 23, 5)),
    loZones(zone(27, 52.6, 18, 51), zone(27, 71, 27, 51))
);

export const LEAP_DAY_ZONES = combineZones(
    topBarZones(zone(10.3, 6.5, 43, 5), zone(10.3, 63, 23, 5)),
    loZones(zone(23, 51, 22, 48), zone(23, 73.5, 23, 48))
);

export const LEAP_DAY_POST_AREA = postArea(12.5, 35, 22.5, 7);

export const COMMON_NIGHT_ZONES = combineZones(
    NIGHT_TOPBAR_ZONES,
    loZones(zone(27.8, 51.5, 20, 68), zone(27.8, 72, 25, 68))
);

export const KP_DAY_ZONES = topBarZones(
    zone(11.5, 7, 42, 5),
    zone(11.5, 65, 24, 5)
);

export const KP_NIGHT_ZONES = combineZones(
    topBarZones(zone(9.8, 7, 43, 5), zone(9.8, 60, 23, 5)),
    loZones(zone(28.5, 51.5, 20, 68), zone(28.5, 72, 25, 68))
);

// Typography fallback is used only when a layout does not provide a
// lottery-specific textStyle.postRow override.
export const DEFAULT_POST_TYPOGRAPHY = {
    twoDColor: COLORS.black,
    threeDColor: COLORS.black,
    fontSize: FONT_SIZES.post,
};

export const TC_POST_TYPOGRAPHY = {
    twoDColor: COLORS.red,
    threeDColor: COLORS.black,
    fontSize: FONT_SIZES.post,
};

// LO layout controls internal spacing only.
// Outer placement still belongs to zones.lo2d / zones.lo3d.
export const DEFAULT_LO_LAYOUT = {
    rowGap: "1%",
    columnGap: "3%",
    columns: 2,
};

export const NIGHT_LO_LAYOUT = {
    ...DEFAULT_LO_LAYOUT,
};

export const DEFAULT_POST_AREA = postArea(27, 68, 26.5, 9.5);

export const KP_DAY_POST_TYPOGRAPHY = {
    twoDColor: COLORS.white,
    threeDColor: COLORS.white,
    fontSize: FONT_PRESETS.md,
};

export const KP_DAY_PAIR_STYLE = {
    rowGap: "45%",
    columnGap: "30%",
};

export const pairValueStyle = (style = {}) => ({
    twoDColor: style.twoDColor,
    threeDColor: style.threeDColor,
    fourDColor: style.fourDColor,
    fontSize: style.fontSize,
    twoDFontSize: style.twoDFontSize,
    threeDFontSize: style.threeDFontSize,
    columnGap: style.columnGap,
});

export const valueGridLayoutStyle = (layout = {}) => ({
    rowGap: layout.rowGap,
    columnGap: layout.columnGap,
    columns: layout.columns,
});

export const createMultiRowSection = ({
    key,
    frame,
    codes,
    layout = {},
    style = {},
    className,
}) => ({
    key,
    kind: "multi-row",
    source: "posts",
    pos: frame,
    codes,
    className,
    ...layout,
    ...style,
});

export const createPairColumnSection = ({
    key,
    frame,
    codes,
    layout = {},
    style = {},
    className,
}) => ({
    key,
    kind: "pair-column",
    source: "posts",
    pos: frame,
    codes,
    className,
    ...layout,
    ...style,
});

export const createPairListRangeSection = ({
    key,
    frame,
    range,
    layout = {},
    style = {},
    className,
}) => ({
    key,
    kind: "pair-list-range",
    source: "lo",
    pos: frame,
    start: range.start,
    end: range.end,
    className,
    ...layout,
    ...style,
});

export const createPairListColumnSection = ({
    key,
    frame,
    columnNumber,
    layout = {},
    style = {},
    className,
}) => ({
    key,
    kind: "pair-list-column",
    source: "lo",
    pos: frame,
    columnNumber,
    className,
    ...layout,
    ...style,
});

export const createValueGridSection = ({
    key,
    frame,
    valueKey,
    layout = {},
    style = {},
}) => ({
    key,
    kind: "value-grid",
    source: "lo",
    valueKey,
    pos: frame,
    ...layout,
    ...style,
});

export const createPostRowsSection = ({
    key = "posts",
    area,
    codes,
    groups,
    excludeAGroup,
    valueKeys = ["twoDigit", "threeDigit"],
    valueColors,
    valueColumns,
    style = {},
}) => ({
    key,
    kind: "post-rows",
    frame: area.frame,
    rowTemplate: area.rows,
    codes,
    groups,
    excludeAGroup,
    valueKeys,
    valueColors,
    valueColumns,
    ...style,
});

export const createAGroupSection = ({ aGroup, postTypography }) => ({
    key: "a-group",
    kind: "a-group",
    pos: aGroup.frame,
    twoDCodes: aGroup.codes?.twoD,
    threeDCodes: aGroup.codes?.threeD,
    ...aGroup.layout,
    fontSize: aGroup.fontSize,
    ...pairValueStyle(postTypography),
});

const resolvePairTypography = (style = {}) => ({
    twoDColor: style.twoDColor,
    threeDColor: style.threeDColor,
    fourDColor: style.fourDColor,
    fontSize: style.fontSize,
    offsetY: style.offsetY,
    fontFamily: style.fontFamily,
    fontWeight: style.fontWeight,
    letterSpacing: style.letterSpacing,
    textShadow: style.textShadow,
    twoDFontSize: style.twoDFontSize,
    threeDFontSize: style.threeDFontSize,
    columnGap: style.columnGap,
    platformAdjust: style.platformAdjust,
});

const resolveValueTypography = (style = {}) => ({
    textColor: style.textColor,
    fontSize: style.fontSize,
    offsetY: style.offsetY,
    fontFamily: style.fontFamily,
    fontWeight: style.fontWeight,
    letterSpacing: style.letterSpacing,
    lineHeight: style.lineHeight,
    textShadow: style.textShadow,
    platformAdjust: style.platformAdjust,
});

// Layout builder contract:
// - zones: absolute placeholder boxes on the background image
// - textStyle: lottery-specific overlay typography/colors
// - postTypography: fallback for post rows / a-group when textStyle is absent
// - loLayout: internal LO grid spacing only (not colors, not font size)
export const createStandardLayout = ({
    ratio = DEFAULT_RATIO,
    zones = MC_DAY_ZONES,
    postArea = DEFAULT_POST_AREA,
    postTypography = DEFAULT_POST_TYPOGRAPHY,
    loLayout = DEFAULT_LO_LAYOUT,
    postGroups,
    postCodes,
    postValueKeys = ["twoDigit", "threeDigit"],
    postValueColumns,
    aGroup,
    textStyle = TEXT_STYLES.default,
}) => {
    const sections = [];
    const postRowTypography = resolvePairTypography(
        textStyle.postRow || pairValueStyle(postTypography)
    );
    const aGroupTypography = resolvePairTypography(
        textStyle.aGroup || pairValueStyle(postTypography)
    );
    const lo2dTypography = resolveValueTypography(
        textStyle.lo2d || TEXT_STYLES.default.lo2d
    );
    const lo3dTypography = resolveValueTypography(
        textStyle.lo3d || TEXT_STYLES.default.lo3d
    );

    if (aGroup) {
        sections.push({
            ...createAGroupSection({ aGroup, postTypography }),
            ...aGroupTypography,
        });
    }

    sections.push(
        createPostRowsSection({
            area: postArea,
            codes: postCodes,
            groups: postGroups,
            excludeAGroup: Boolean(aGroup),
            valueKeys: postValueKeys,
            valueColors: postValueKeys.map((key) => {
                if (key === "twoDigit") return postRowTypography.twoDColor;
                if (key === "threeDigit") return postRowTypography.threeDColor;
                if (key === "fourDigit") return postRowTypography.fourDColor;
                return postRowTypography.twoDColor;
            }),
            valueColumns: postValueColumns,
            style: postRowTypography,
        })
    );

    sections.push(
        createValueGridSection({
            key: "lo-2d",
            frame: zones.lo2d,
            valueKey: "twoDigit",
            style: {
                ...valueGridLayoutStyle(loLayout),
                ...lo2dTypography,
            },
        })
    );

    sections.push(
        createValueGridSection({
            key: "lo-3d",
            frame: zones.lo3d,
            valueKey: "threeDigit",
            style: {
                ...valueGridLayoutStyle(loLayout),
                ...lo3dTypography,
            },
        })
    );

    return {
        ratio,
        zones,
        textStyle,
        sections,
    };
};

export const createSimpleLotteryConfig = ({
    bg,
    ratio = DEFAULT_RATIO,
    zones = MC_DAY_ZONES,
    textStyle = TEXT_STYLES.default,
    postArea = DEFAULT_POST_AREA,
    postTypography = DEFAULT_POST_TYPOGRAPHY,
    loLayout = DEFAULT_LO_LAYOUT,
    postCodes,
    postGroups,
    postValueKeys,
    postValueColumns,
    aGroup,
}) => ({
    bg,
    layout: createStandardLayout({
        ratio,
        zones,
        textStyle,
        postArea,
        postTypography,
        loLayout,
        postCodes,
        postGroups,
        postValueKeys,
        postValueColumns,
        aGroup,
    }),
});

export const toPercentStyle = (zone = {}) => ({
    top: `${zone.top}%`,
    left: `${zone.left}%`,
    width: `${zone.width}%`,
    height: `${zone.height}%`,
});
